import {mapState} from "vuex";

export const sidebarState = {
  computed: {
    ...mapState({
      sidebarOpen: state => state.sidebar.showFull
    })
  }
}
